import React from 'react'
import { Row, Col, Text, Title } from '@dataesr/react-dsfr'

export default function MentionsLegales() {
  return (
    <Row>
      <Col>
        <Title as='h1'>Mentions légales</Title>
        <Text></Text>
        <Title as='h2' look='h2'>
          Éditeur de la Plateforme
        </Title>
        <Text>
          Ce site constitué par l’ensemble des pages rattachées à son nom de
          domaine est la propriété de l’Agence de la transition écologique
          (ADEME). Etablissement Public à caractère Industriel et Commercial
          (EPIC) régi par les articles L131-3 à L131-7 et R131-1 à R131-26 du
          Code de l’environnement, ayant son siège social au :
        </Text>
        <Text>
          20, avenue du Grésillé
          <br /> BP 90406
          <br /> 49004 Angers Cedex 01
          <br /> Tél. : 02 41 20 41 20
        </Text>
        <Text>
          inscrit au registre du commerce d'Angers sous le n° 385 290 309,
          représentée par Arnaud Leroy, agissant en qualité de Président du
          conseil d'administration.
        </Text>
        <Text>
          Le Directeur de la publication est Monsieur Arnaud Leroy, en qualité
          de représentant légal de l’ADEME.
        </Text>
        <Text>
          La personne responsable de l'accès aux documents administratifs et des
          questions relatives à la réutilisation des informations est Monsieur
          Luc Morinière en qualité de Directeur des affaires juridiques et
          achats.
        </Text>
        <Title as='h2' look='h2'>
          Hébergement
        </Title>
        <Text>
          Ce site (et ses données) sonts hébergées par : CLEVERCLOUD 3 rue de
          l'Allier 44000 Nantes.
          <br />
          <br />
          L'affichage du site est géré par Netlify, Inc 2325 3rd Street, Suite
          296, San Francisco, California 94107.
          <br />
          <br />
          L'ensemble des données utilisateurs sont hébérgées en France.
        </Text>
        <Title as='h2' look='h2'>
          Conditions d'utilisation
        </Title>
        <Text>
          L’utilisation de ce site est subordonnée à l’acceptation de
          l’intégralité des présentes conditions exposées ci-après.
        </Text>
        <Title as='h2' look='h2'>
          Informations contenues dans le site
        </Title>
        <Text>
          Les informations fournies sur ce site le sont à titre informatif.
          L’ADEME ne saurait garantir l'exactitude, la complétude, l'actualité
          des informations diffusées sur le site. L’ADEME met tout en œuvre pour
          offrir aux utilisateurs des informations et/ou outils disponibles et
          vérifiés, mais ne saurait être tenue pour responsable des erreurs ou
          omissions, d'une absence de disponibilité des informations et des
          services. En conséquence, l'utilisateur reconnaît utiliser ces
          informations sous sa responsabilité exclusive. L’utilisateur déclare
          avoir pris connaissance des informations ci-dessus avant la visite du
          site. En choisissant d’accéder au site, l’utilisateur accepte,
          expressément et irrévocablement, les termes ci-après.{' '}
        </Text>
        <Title as='h2' look='h2'>
          Cookies de navigation
        </Title>
        <Text>
          L'ADEME souhaite vous informer de manière claire et transparente sur
          l'usage des cookies lorsque vous consultez les sites ademe.fr.
        </Text>
        <Text>
          Lorsque vous consultez les sites ademe.fr, des informations relatives
          à la navigation sont également susceptibles d’être enregistrées dans
          des fichiers textes appelés « cookies » installés sur votre ordinateur
          ou appareil mobile. Le terme « cookie » recouvre les différents
          traceurs qui sont déposés ou lus sur votre terminal (ordinateur,
          tablette, smartphone…) lors de votre navigation sur des pages internet
          sous réserve des choix que vous avez exprimés. Les cookies sont
          utilisés sur les sites ademe.fr pour différentes finalités, pour
          faciliter votre navigation, pour vous proposer des contenus
          personnalisés ou pour réaliser des statistiques de visites.
        </Text>
        <Text>
          Les cookies suivants sont susceptibles d’être déposés sur les sites
          ademe.fr :<br />
          Des cookies de navigation et de préférence, pour vous proposer une
          navigation selon votre profil (entreprises,
          collectivités/institutionnel/journaliste) et vous permettre d’accéder
          plus facilement aux contenus du site. Les cookies de préférence
          permettent également de stocker des contenus en favoris sur certains
          de nos sites ;<br />
          Des cookies d’authentification, indispensables pour vous permettre
          d’accéder à votre espace personnel depuis différents sites ;<br />
          Des cookies de performance, pour élaborer des statistiques via l’outil
          Google Analytics et optimiser les performances des sites.
        </Text>
        <Text>
          Nos sites contiennent des liens vers d’autres sites internet qui
          utilisent des cookies, notamment des liens de partage vers les réseaux
          sociaux. Nous vous invitons à consulter leur propre politique de
          gestion de cookies.
        </Text>
        <Text>
          La base légale d’utilisation de ces cookies est votre consentement.
          Conformément à la réglementation applicable, ces cookies ont une durée
          de validité de 13 mois maximum, au-delà desquels votre consentement
          sera de nouveau sollicité par un l’affichage d’un bandeau
          d’informations.
          <br />
          Ces données sont réservées à l'usage des services concernés de l'ADEME
          et sont exploitées via Google Analytics.
        </Text>
        <Title as='h2' look='h2'>
          Droits de Propriété Intellectuelle
        </Title>
        <Text>
          Tous les éléments (textes, logos, images, éléments sonores, logiciels,
          icônes, mises en page, bases de données,...) contenus dans le site et
          dans les sites associés sont protégés par le droit national et
          international de la propriété intellectuelle. Ces éléments restent la
          propriété exclusive de l’ADEME et/ou de ses partenaires.
        </Text>
        <Text>
          A ce titre, vous ne pouvez procéder à une quelconque reproduction,
          représentation, adaptation, traduction et/ou transformation partielle
          ou intégrale, ou un transfert sur un autre site web de tout élément
          composant le site. Le non-respect de cette interdiction peut
          constituer un acte de contrefaçon engageant vos responsabilités civile
          et pénale. Conformément aux dispositions du Code de la propriété
          Intellectuelle, seule est autorisée l'utilisation des éléments
          composant le site à des fins strictement personnelles.
        </Text>
        <Text>
          Cependant si vous souhaitez utiliser les éléments disponibles sur le
          site ademe.fr nous vous invitons à consulter nos Conditions Générales
          d'Utilisation (CGU).
        </Text>
        <Title as='h2' look='h2'>
          Liens hypertextes
        </Title>
        <Text>
          L'ADEME décline toute responsabilité quant au contenu des sites
          proposés en liens. La mise en place de liens hypertextes vers des
          pages ou des documents diffusés sur le site ademe.fr est autorisée si
          les liens garantissent la possibilité d’identifier l’origine ADEME du
          document. L’utilisateur devra en informer préalablement l’ADEME. Toute
          utilisation d’information doit faire l’objet d’une demande
          d’autorisation, qui peut être sollicitée auprès du service
          Communication de l’ADEME. Celle-ci sera accordée si la demande ne
          contrevient pas aux intérêts de l’ADEME. L’ADEME se réserve le droit
          de poursuivre toute personne qui ne respecterait pas l’application de
          ces règles.
        </Text>
        <Text>
          Ce site est un site portail donnant accès à d'autres sites appartenant
          ou non à l’ADEME, susceptibles de disposer de leurs propres notices
          légales, qu'il convient de consulter et de respecter.
        </Text>
        <Title as='h2' look='h2'>
          Votre attention
        </Title>
        <Text>
          Nous vous rappelons qu’il n’est pas possible de garantir la
          confidentialité des messages transmis sur le réseau Internet. Aussi,
          si vous souhaitez transmettre un message dans de meilleures conditions
          de sécurité, nous vous recommandons d’utiliser la voie postale.
          L’ADEME dégage toute responsabilité quant aux difficultés techniques
          que vous pourriez rencontrer sur le site qu’elles qu’en soient la
          cause et l’origine.
        </Text>
        <Title as='h2' look='h2'>
          Modification des mentions légales
        </Title>
        <Text>
          L’ADEME se réserve le droit de modifier les présentes mentions à tout
          moment. L’utilisateur est lié par les conditions en vigueur lors de sa
          visite.
        </Text>
        <Title as='h2' look='h2'>
          Droit applicable en cas de litige
        </Title>
        <Text>
          Le droit applicable est le droit français.
          <br />
          Pour tout litige, il est fait attribution exclusive de juridiction aux
          tribunaux compétents du ressort de la Cour d'Appel d’ANGERS (France).
          <br />© 2021 - ADEME - Tous droits réservés - Mentions légales
        </Text>
      </Col>
    </Row>
  )
}
